import { Box, Chip, TextField, makeStyles } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import React, { useState } from "react";

const useStyles = makeStyles(() => ({
  root: {
    width: "100%",
    minWidth: 0,
    "& .MuiAutocomplete-inputRoot": {
      flexWrap: "nowrap !important",
      overflow: "hidden",
      alignItems: "center",
      maxHeight: 40,
    },
    "& .MuiAutocomplete-tag": {
      maxWidth: "calc(100% - 36px)",
      margin: "1px 2px 1px 0 !important",
    },
    "& .MuiChip-root": {
      height: 20,
      maxWidth: "100%",
    },
    "& .MuiChip-label": {
      paddingLeft: 4,
      paddingRight: 4,
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    },
  },
  limitTag: {
    height: 20,
    fontSize: "0.62rem",
    backgroundColor: "rgba(0,0,0,0.08)",
    margin: "1px 0 !important",
  },
}));

const channelOptions = [
  { id: "whatsapp", name: "WhatsApp" },
  { id: "whatsapp_oficial", name: "WhatsApp Oficial" },
  { id: "wuzapi", name: "WuzAPI" },
  { id: "facebook", name: "Facebook" },
  { id: "instagram", name: "Instagram" },
  { id: "telegram", name: "Telegram" },
  { id: "email", name: "Email" },
  { id: "webchat", name: "WebChat" },
];

export function ChannelFilter({ onFiltered }) {
  const classes = useStyles();
  const [selecteds, setSelecteds] = useState([]);

  const onChange = (value) => {
    setSelecteds(value);
    onFiltered(value);
  };

  return (
    <Box className={classes.root}>
      <Autocomplete
        multiple
        size="small"
        options={channelOptions}
        value={selecteds}
        onChange={(e, v) => onChange(v)}
        getOptionLabel={(option) => option.name}
        getOptionSelected={(option, value) => option.id === value.id}
        renderTags={(value, getTagProps) => {
          if (!value.length) return null;
          if (value.length === 1) {
            return [
              <Chip
                key={value[0].id}
                variant="outlined"
                style={{ borderRadius: 4 }}
                label={value[0].name}
                {...getTagProps({ index: 0 })}
                size="small"
              />,
            ];
          }
          return [
            <Chip
              key="channels-summary"
              className={classes.limitTag}
              size="small"
              label={`${value.length} canais`}
              onDelete={() => onChange([])}
            />,
          ];
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            placeholder={selecteds.length ? "" : "Canal"}
            label="Canal"
          />
        )}
      />
    </Box>
  );
}

export default ChannelFilter;
